import React from "react";

type Props = { isManager?: boolean; availableCount: number };

export default function AirMonitoringSensorFixNotice({
  availableCount,
  isManager = false,
}: Props) {
  // 매니저이면서 가용센서가 갯수가 0인경우에만 통신 단절 오류 표시
  if ( !isManager || (isManager && availableCount > 0) ) return null;

  return (
    <div className="whitespace-pre-line text-center py-5 px-2.5 bg-brand-weather-badge-background text-sm text-brand-neutral-80">
      센서점검 확인 : 통신 단절 발생
    </div>
  );
}
